module.exports = __webpack_public_path__ + "media/images/plans/ceremony/hall-list/plan-ceremony-lineup-kanto-2-d568aaf3a9fd549c6b0e6ae84b456aed.png";